import { useCallback, useState } from 'react';
import { DEFAULT_SEARCH_STATE, SearchFilterState } from 'screens/Main/Search/searchState';
import { CardFilterStateApi, useFilterStateApi } from './cardFilterUrlState';

/**
 * The same CardFilterStateApi as useCardFilterState, held in component state
 * instead of the URL.
 *
 * For a surface that keeps filters per sub-view and must not write them to the
 * address bar: the offer builder holds one of these per side so switching the
 * focused side swaps which api the rail gets, and the other side's filters
 * wait in memory for the session (Asana 1219788320590626 Decision 6).
 */
export const useLocalCardFilterState = (
  initial: SearchFilterState = DEFAULT_SEARCH_STATE,
): CardFilterStateApi => {
  const [state, setState] = useState<SearchFilterState>(initial);
  const commit = useCallback((next: SearchFilterState) => setState(next), []);
  return useFilterStateApi(state, commit);
};

export default useLocalCardFilterState;
